import PropTypes from "prop-types";
import React from "react";

import Authorization from "../../app/components/Authorization";
import {ButtonAdd} from "../../app/components/ButtonCollection";
import Link from "../../app/components/Link";

import {CLIENT_CDN_CONFIGURATION} from "../../app/constants/resources";
import {SECURITY_PRIVILEGES_CREATE} from "../../app/constants/variables";

const CdnConfigurationsIndexButtons = (props) => (
    <div className="content__buttons">
        <Authorization
            privileges={SECURITY_PRIVILEGES_CREATE}
            resources={CLIENT_CDN_CONFIGURATION}
        >
            <Link name={'clients.clientCdnConfiguration.add'} params={{id: props.clientId}}>
                <ButtonAdd>{'Add new CDN configuration'}</ButtonAdd>
            </Link>
        </Authorization>
    </div>
);

CdnConfigurationsIndexButtons.propTypes = {
    clientId: PropTypes.number.isRequired,
};

export default CdnConfigurationsIndexButtons;
